export const srRoutes = [
  { key: 'CIS', route: '/suite-reports/invoice-status' },
];
